<div class="tables-page">

  <!-- ==================================================
       HEADER
       ================================================== -->

  <header class="page-header">

    <div>

      <span class="page-label">
        Atendimento
      </span>

      <h1>
        Gerenciamento de mesas
      </h1>

      <p>
        Acompanhe comandas, pedidos, pagamentos
        e solicitações do salão.
      </p>

    </div>


    <button
      type="button"
      class="refresh-button"
      [disabled]="loading"
      (click)="loadTables()"
    >
      {{
        loading
          ? 'Atualizando...'
          : 'Atualizar'
      }}
    </button>

  </header>


  <!-- ==================================================
       MENSAGENS
       ================================================== -->

  <div
    class="message success-message"
    *ngIf="successMessage"
  >
    {{ successMessage }}
  </div>


  <div
    class="message error-message"
    *ngIf="errorMessage"
  >
    {{ errorMessage }}
  </div>


  <!-- ==================================================
       RESUMO
       ================================================== -->

  <section class="status-summary">

    <button
      type="button"
      class="summary-card available"
      (click)="
        statusFilter =
          'AVAILABLE'
      "
    >

      <span>
        Disponíveis
      </span>

      <strong>
        {{ availableCount }}
      </strong>

    </button>


    <button
      type="button"
      class="summary-card occupied"
      (click)="
        statusFilter =
          'OCCUPIED'
      "
    >

      <span>
        Ocupadas
      </span>

      <strong>
        {{ occupiedCount }}
      </strong>

    </button>


    <button
      type="button"
      class="summary-card bill"
      (click)="
        statusFilter =
          'BILL_REQUESTED'
      "
    >

      <span>
        Conta solicitada
      </span>

      <strong>
        {{ billRequestedCount }}
      </strong>

    </button>


    <button
      type="button"
      class="summary-card payment"
      (click)="
        statusFilter =
          'AWAITING_PAYMENT'
      "
    >

      <span>
        Aguardando pagamento
      </span>

      <strong>
        {{ awaitingPaymentCount }}
      </strong>

    </button>


    <!-- CHAMADOS -->

    <button
      type="button"
      class="summary-card service-request"
      [class.has-alert]="
        pendingRequestsCount > 0
      "
    >

      <div class="summary-request-title">

        <span class="summary-request-icon">
          🔔
        </span>

        <span>
          Chamados
        </span>

      </div>


      <strong>
        {{ pendingRequestsCount }}
      </strong>

    </button>

  </section>


  <!-- ==================================================
       FILTROS
       ================================================== -->

  <section class="filters">

    <input
      type="search"
      [(ngModel)]="searchText"
      placeholder="Buscar mesa, número ou área..."
    >


    <select
      [(ngModel)]="statusFilter"
    >

      <option value="">
        Todos os status
      </option>

      <option value="AVAILABLE">
        Disponíveis
      </option>

      <option value="OCCUPIED">
        Ocupadas
      </option>

      <option value="RESERVED">
        Reservadas
      </option>

      <option value="BILL_REQUESTED">
        Conta solicitada
      </option>

      <option value="AWAITING_PAYMENT">
        Aguardando pagamento
      </option>

      <option value="UNAVAILABLE">
        Indisponíveis
      </option>

    </select>


    <button
      type="button"
      class="clear-filter-button"
      (click)="
        searchText = '';
        statusFilter = ''
      "
    >
      Limpar
    </button>

  </section>


  <!-- ==================================================
       LOADING
       ================================================== -->

  <div
    class="loading-state"
    *ngIf="loading"
  >
    Carregando mesas...
  </div>


  <!-- ==================================================
       VAZIO
       ================================================== -->

  <div
    class="empty-state"
    *ngIf="
      !loading &&
      filteredTables.length === 0
    "
  >
    Nenhuma mesa encontrada.
  </div>


  <!-- ==================================================
       MESAS
       ================================================== -->

  <section
    class="tables-grid"
    *ngIf="!loading"
  >

    <article
      class="table-card"
      *ngFor="
        let table
        of filteredTables;
        trackBy: trackTable
      "
      [attr.data-status]="
        table.status
      "
      [class.has-service-request]="
        hasPendingRequest(
          table.id
        )
      "
    >

      <!-- CABEÇALHO -->

      <div class="table-card-header">

        <div>

          <span class="table-area">
            {{
              table.area ||
              'Salão principal'
            }}
          </span>

          <h2>
            {{ table.name }}
          </h2>

          <small
            *ngIf="
              table.capacity
            "
          >
            Capacidade:
            {{ table.capacity }}
          </small>

        </div>


        <span
          class="status-badge"
          [attr.data-status]="
            table.status
          "
        >
          {{
            getStatusLabel(
              table.status
            )
          }}
        </span>

      </div>


      <!-- ==================================================
           CHAMADOS DA MESA
           ================================================== -->

      <section
        class="table-service-alerts"
        *ngIf="
          hasPendingRequest(
            table.id
          )
        "
      >

        <!-- CHAMAR GARÇOM -->

        <article
          class="service-alert waiter-alert"
          *ngIf="
            getWaiterRequest(
              table.id
            ) as waiterRequest
          "
        >

          <div class="service-alert-icon">
            🔔
          </div>


          <div class="service-alert-content">

            <span>
              Atendimento solicitado
            </span>

            <strong>
              Garçom solicitado
            </strong>

            <small>
              {{
                getRequestAge(
                  waiterRequest
                )
              }}
            </small>

          </div>


          <button
            type="button"
            class="attend-request-button"
            [disabled]="
              isAttendingRequest(
                waiterRequest.id
              )
            "
            (click)="
              attendServiceRequest(
                waiterRequest
              )
            "
          >
            {{
              isAttendingRequest(
                waiterRequest.id
              )
                ? 'Atendendo...'
                : '✓ Atendido'
            }}
          </button>

        </article>


        <!-- SOLICITOU ABERTURA -->

        <article
          class="
            service-alert
            open-session-alert
          "
          *ngIf="
            getOpenSessionRequest(
              table.id
            ) as openRequest
          "
        >

          <div class="service-alert-icon">
            🙋
          </div>


          <div class="service-alert-content">

            <span>
              Cliente aguardando
            </span>

            <strong>
              Abertura de comanda solicitada
            </strong>

            <small>
              {{
                getRequestAge(
                  openRequest
                )
              }}
            </small>

          </div>


          <div class="service-alert-actions">

            <!--
              Continua usando a abertura
              normal da comanda.
            -->

            <button
              type="button"
              class="open-request-button"
              *ngIf="
                table.status ===
                'AVAILABLE'
              "
              (click)="
                openSessionModal(
                  table
                )
              "
            >
              Abrir comanda
            </button>


            <button
              type="button"
              class="dismiss-request-button"
              [disabled]="
                isAttendingRequest(
                  openRequest.id
                )
              "
              (click)="
                attendServiceRequest(
                  openRequest
                )
              "
            >
              {{
                isAttendingRequest(
                  openRequest.id
                )
                  ? 'Atualizando...'
                  : 'Marcar atendido'
              }}
            </button>

          </div>

        </article>

      </section>


      <!-- ==================================================
           COMANDA ATIVA
           ================================================== -->

      <div
        class="session-information"
        *ngIf="
          table.activeSession
        "
      >

        <div>

          <span>
            Cliente
          </span>

          <strong>
            {{
              table
                .activeSession
                .customerName ||
              'Não informado'
            }}
          </strong>

        </div>


        <div>

          <span>
            Pessoas
          </span>

          <strong>
            {{
              table
                .activeSession
                .customerCount ||
              1
            }}
          </strong>

        </div>


        <div>

          <span>
            Aberta em
          </span>

          <strong>
            {{
              table
                .activeSession
                .openedAt
                | date:
                  'dd/MM HH:mm'
            }}
          </strong>

        </div>

      </div>


      <!-- ==================================================
           AÇÕES
           ================================================== -->

      <div class="table-actions">

        <!--
          IMPORTANTE:
          abertura manual continua existindo
          mesmo sem solicitação do cliente.
        -->

        <button
          type="button"
          class="primary-button"
          *ngIf="
            table.status ===
            'AVAILABLE'
          "
          (click)="
            openSessionModal(
              table
            )
          "
        >
          Abrir comanda
        </button>


        <button
          type="button"
          class="payment-button"
          *ngIf="
            table.activeSession &&
            (
              table.status ===
                'BILL_REQUESTED' ||
              table.status ===
                'AWAITING_PAYMENT'
            )
          "
          (click)="
            viewSession(
              table
            )
          "
        >
          Receber pagamento
        </button>


        <button
          type="button"
          class="secondary-button"
          *ngIf="
            table.activeSession &&
            table.status !==
              'BILL_REQUESTED' &&
            table.status !==
              'AWAITING_PAYMENT'
          "
          (click)="
            viewSession(
              table
            )
          "
        >
          Ver comanda
        </button>


        <button
          type="button"
          class="disabled-action"
          *ngIf="
            table.status ===
            'UNAVAILABLE'
          "
          disabled
        >
          Mesa indisponível
        </button>

      </div>

    </article>

  </section>

</div>


<!-- ==================================================
     MODAL - ABRIR COMANDA
     ================================================== -->

<div
  class="modal-backdrop"
  *ngIf="
    showOpenSessionModal
  "
  (click)="
    closeAllModals()
  "
></div>


<section
  class="modal"
  *ngIf="
    showOpenSessionModal
  "
>

  <div class="modal-header">

    <div>

      <span>
        Abertura de comanda
      </span>

      <h2>
        {{ selectedTable?.name }}
      </h2>

    </div>


    <button
      type="button"
      class="close-button"
      (click)="
        closeAllModals()
      "
    >
      ×
    </button>

  </div>


  <div class="form-grid">

    <label class="full-field">

      Nome do cliente

      <input
        type="text"
        [(ngModel)]="
          openSessionForm
            .customerName
        "
        maxlength="150"
        placeholder="Nome opcional"
      >

    </label>


    <label>

      Quantidade de pessoas

      <input
        type="number"
        [(ngModel)]="
          openSessionForm
            .customerCount
        "
        min="1"
        max="100"
      >

    </label>


    <label>

      Taxa de serviço (%)

      <input
        type="number"
        [(ngModel)]="
          openSessionForm
            .serviceFeeRate
        "
        min="0"
        max="100"
        step="0.01"
      >

    </label>


    <label>

      Desconto inicial

      <input
        type="number"
        [(ngModel)]="
          openSessionForm
            .discountAmount
        "
        min="0"
        step="0.01"
      >

    </label>


    <label class="full-field">

      Observações

      <textarea
        [(ngModel)]="
          openSessionForm
            .notes
        "
        maxlength="1000"
        rows="3"
      ></textarea>

    </label>

  </div>


  <div class="modal-footer">

    <button
      type="button"
      class="secondary-button"
      (click)="
        closeAllModals()
      "
    >
      Cancelar
    </button>


    <button
      type="button"
      class="primary-button"
      [disabled]="saving"
      (click)="
        openSession()
      "
    >
      {{
        saving
          ? 'Abrindo...'
          : 'Abrir comanda'
      }}
    </button>

  </div>

</section>


<!-- ==================================================
     MODAL - VISUALIZAR COMANDA
     ================================================== -->

<div
  class="modal-backdrop"
  *ngIf="
    showSessionModal
  "
  (click)="
    closeAllModals()
  "
></div>


<section
  class="modal large-modal"
  *ngIf="
    showSessionModal
  "
>

  <div class="modal-header">

    <div>

      <span>
        Comanda
      </span>

      <h2>
        {{ selectedTable?.name }}
      </h2>


      <small
        *ngIf="
          selectedSession
        "
      >
        {{
          getStatusLabel(
            selectedSession.status
          )
        }}
      </small>

    </div>


    <button
      type="button"
      class="close-button"
      (click)="
        closeAllModals()
      "
    >
      ×
    </button>

  </div>


  <div
    class="loading-state"
    *ngIf="
      loadingSession
    "
  >
    Carregando comanda...
  </div>


  <ng-container
    *ngIf="
      !loadingSession &&
      selectedSession
    "
  >

    <!-- RESUMO -->

    <section class="financial-summary">

      <div>

        <span>
          Total
        </span>

        <strong>
          {{
            totalAmount
              | currency:
                'BRL':
                'symbol':
                '1.2-2':
                'pt-BR'
          }}
        </strong>

      </div>


      <div>

        <span>
          Pago
        </span>

        <strong>
          {{
            paidAmount
              | currency:
                'BRL':
                'symbol':
                '1.2-2':
                'pt-BR'
          }}
        </strong>

      </div>


      <div>

        <span>
          Restante
        </span>

        <strong>
          {{
            remainingAmount
              | currency:
                'BRL':
                'symbol':
                '1.2-2':
                'pt-BR'
          }}
        </strong>

      </div>

    </section>


    <!-- PEDIDOS -->

    <section class="modal-section">

      <div class="section-header">

        <h3>
          Pedidos
        </h3>

        <span>
          {{ orders.length }}
        </span>

      </div>


      <p
        class="empty-section"
        *ngIf="
          orders.length === 0
        "
      >
        Nenhum pedido realizado.
      </p>


      <article
        class="order-card"
        *ngFor="
          let order
          of orders
        "
      >

        <div class="order-header">

          <div>

            <strong>
              Pedido #{{ order.id }}
            </strong>

            <small>
              {{
                order.createdAt
                  | date:
                    'dd/MM/yyyy HH:mm'
              }}
            </small>

          </div>


          <span class="order-status">
            {{
              getOrderStatusLabel(
                order.status
              )
            }}
          </span>

        </div>


        <div class="order-items">

          <div
            class="order-item"
            *ngFor="
              let item
              of order.items
            "
          >

            <span>
              {{ item.quantity }}×
              {{
                item.product?.name ||
                'Produto'
              }}
            </span>


            <strong>
              {{
                toNumber(
                  item.unitPrice
                ) *
                item.quantity
                  | currency:
                    'BRL':
                    'symbol':
                    '1.2-2':
                    'pt-BR'
              }}
            </strong>

          </div>

        </div>

      </article>

    </section>


    <!-- PAGAMENTOS -->

    <section class="modal-section">

      <div class="section-header">

        <h3>
          Pagamentos
        </h3>

        <span>
          {{ payments.length }}
        </span>

      </div>


      <p
        class="empty-section"
        *ngIf="
          payments.length === 0
        "
      >
        Nenhum pagamento registrado.
      </p>


      <article
        class="payment-item"
        *ngFor="
          let payment
          of payments
        "
      >

        <div>

          <strong>
            {{
              getPaymentMethodLabel(
                payment.method
              )
            }}
          </strong>

          <small>
            {{
              payment.createdAt
                | date:
                  'dd/MM/yyyy HH:mm'
            }}
          </small>

        </div>


        <div class="payment-value">

          <strong>
            {{
              toNumber(
                payment.amount
              )
                | currency:
                  'BRL':
                  'symbol':
                  '1.2-2':
                  'pt-BR'
            }}
          </strong>


          <button
            type="button"
            class="text-danger"
            *ngIf="
              payment.status ===
              'PAID'
            "
            [disabled]="saving"
            (click)="
              cancelPayment(
                payment.id
              )
            "
          >
            Cancelar
          </button>

        </div>

      </article>

    </section>


    <!-- RESTANTE -->

    <div
      class="remaining-highlight"
      *ngIf="
        canRegisterPayment ||
        canCloseSession
      "
    >

      <span>
        {{
          remainingAmount >
          0.009
            ? 'Pagamento pendente'
            : 'Pagamento concluído'
        }}
      </span>


      <strong>
        {{
          remainingAmount
            | currency:
              'BRL':
              'symbol':
              '1.2-2':
              'pt-BR'
        }}
      </strong>

    </div>


    <p
      class="empty-section"
      *ngIf="
        canRegisterPayment &&
        remainingAmount > 0.009
      "
    >
      Registre o pagamento recebido para depois fechar a
      comanda e liberar a mesa.
    </p>


    <p
      class="empty-section"
      *ngIf="
        canCloseSession &&
        remainingAmount <= 0.009
      "
    >
      O pagamento foi concluído.
      Feche a comanda para liberar a mesa.
    </p>


    <!-- AÇÕES -->

    <div class="session-actions">

      <button
        type="button"
        class="secondary-button"
        *ngIf="
          canRequestBill
        "
        [disabled]="saving"
        (click)="
          requestBill()
        "
      >
        Solicitar conta
      </button>


      <button
        type="button"
        class="secondary-button"
        *ngIf="
          selectedSession?.status !==
            'CLOSED' &&
          selectedSession?.status !==
            'CANCELED'
        "
        [disabled]="saving"
        (click)="
          openTransferModal()
        "
      >
        Transferir mesa
      </button>


      <button
        type="button"
        class="payment-button"
        *ngIf="
          canRegisterPayment
        "
        [disabled]="saving"
        (click)="
          openPaymentModal()
        "
      >
        Registrar pagamento
      </button>


      <button
        type="button"
        class="close-session-button"
        *ngIf="
          canCloseSession
        "
        [disabled]="saving"
        (click)="
          closeSession()
        "
      >
        Fechar comanda e liberar mesa
      </button>

    </div>

  </ng-container>

</section>


<!-- ==================================================
     MODAL PAGAMENTO
     ================================================== -->

<div
  class="
    modal-backdrop
    payment-backdrop
  "
  *ngIf="
    showPaymentModal
  "
></div>


<section
  class="modal payment-modal"
  *ngIf="
    showPaymentModal
  "
>

  <div class="modal-header">

    <div>

      <span>
        Pagamento
      </span>

      <h2>
        Registrar pagamento
      </h2>

    </div>


    <button
      type="button"
      class="close-button"
      (click)="
        showPaymentModal =
          false
      "
    >
      ×
    </button>

  </div>


  <div class="remaining-highlight">

    <span>
      Valor restante
    </span>

    <strong>
      {{
        remainingAmount
          | currency:
            'BRL':
            'symbol':
            '1.2-2':
            'pt-BR'
      }}
    </strong>

  </div>


  <div class="form-grid">

    <label>

      Forma de pagamento

      <select
        [(ngModel)]="
          paymentForm.method
        "
      >

        <option value="PIX">
          Pix
        </option>

        <option value="CASH">
          Dinheiro
        </option>

        <option value="DEBIT_CARD">
          Cartão de débito
        </option>

        <option value="CREDIT_CARD">
          Cartão de crédito
        </option>

        <option value="ONLINE">
          On-line
        </option>

        <option value="OTHER">
          Outro
        </option>

      </select>

    </label>


    <label>

      Valor

      <input
        type="number"
        [(ngModel)]="
          paymentForm.amount
        "
        min="0.01"
        [max]="
          remainingAmount
        "
        step="0.01"
      >

    </label>


    <label class="full-field">

      Código da transação

      <input
        type="text"
        [(ngModel)]="
          paymentForm
            .transactionCode
        "
        maxlength="150"
      >

    </label>


    <label class="full-field">

      Observação

      <textarea
        [(ngModel)]="
          paymentForm.notes
        "
        rows="3"
        maxlength="500"
      ></textarea>

    </label>

  </div>


  <div class="modal-footer">

    <button
      type="button"
      class="secondary-button"
      (click)="
        showPaymentModal =
          false
      "
    >
      Cancelar
    </button>


    <button
      type="button"
      class="payment-button"
      [disabled]="saving"
      (click)="
        registerPayment()
      "
    >
      {{
        saving
          ? 'Registrando...'
          : 'Confirmar pagamento'
      }}
    </button>

  </div>

</section>


<!-- ==================================================
     MODAL TRANSFERÊNCIA
     ================================================== -->

<div
  class="modal-backdrop"
  *ngIf="
    showTransferModal
  "
  (click)="
    closeTransferModal()
  "
></div>


<section
  class="modal"
  *ngIf="
    showTransferModal
  "
>

  <div class="modal-header">

    <div>

      <span>
        Transferência de comanda
      </span>

      <h2>
        {{ selectedTable?.name }}
      </h2>

    </div>


    <button
      type="button"
      class="close-button"
      (click)="
        closeTransferModal()
      "
    >
      ×
    </button>

  </div>


  <div class="form-grid">

    <label class="full-field">

      Mesa de destino

      <select
        [(ngModel)]="
          transferTargetTableId
        "
      >

        <option
          [ngValue]="null"
        >
          Selecione uma mesa disponível
        </option>


        <option
          *ngFor="
            let table
            of availableTransferTables
          "
          [ngValue]="
            table.id
          "
        >
          {{ table.name }}
          —
          {{
            table.area ||
            'Salão principal'
          }}
        </option>

      </select>

    </label>

  </div>


  <p
    class="empty-section"
    *ngIf="
      availableTransferTables
        .length === 0
    "
  >
    Não existem mesas disponíveis para transferência.
  </p>


  <div class="modal-footer">

    <button
      type="button"
      class="secondary-button"
      [disabled]="saving"
      (click)="
        closeTransferModal()
      "
    >
      Cancelar
    </button>


    <button
      type="button"
      class="primary-button"
      [disabled]="
        saving ||
        !transferTargetTableId ||
        availableTransferTables
          .length === 0
      "
      (click)="
        transferSession()
      "
    >
      {{
        saving
          ? 'Transferindo...'
          : 'Confirmar transferência'
      }}
    </button>

  </div>

</section>